import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import ConfirmDeleteModalG from '../ConfirmDeleteModal'
import { useDeleteBill } from './queries'

type Props = {
  id: number
  reference: string
}

const ConfirmDeleteModal = ({ id, reference }: Props) => {
  const deleteBill = useDeleteBill()

  return (
    <ConfirmDeleteModalG
      item={id}
      loading={deleteBill.isLoading}
      deleteItem={id => deleteBill.mutate(id)}
    >
      <FormattedMessage id="deleteInvoicePrompt" values={{ id: reference }} />
    </ConfirmDeleteModalG>
  )
}

export default ConfirmDeleteModal
